var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInfection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M596 127c84 37 142 122 142 220 0 18-2 36-6 53 42 10 82 31 115 64 69 70 87 171 54 258-7 16-28 21-40 8-6-6-9-14-7-22 8-42-4-87-37-119-51-50-134-49-184 3-49 51-48 133 2 183 31 32 75 44 116 36 7-1 14 1 20 5l2 2c13 13 8 34-8 41-86 33-187 15-256-55-3-4-6-7-9-10l-3 3-6 7c-69 70-170 88-256 55-15-6-20-25-10-38l2-3c6-6 14-8 22-7 41 8 85-4 116-36 51-50 51-132 2-183-50-52-133-53-184-3-33 32-45 77-37 119 2 8-1 16-6 22-13 13-34 8-41-8-33-87-15-188 54-258 33-33 73-54 115-64-4-16-6-34-6-51-1-99 58-184 142-222 15-7 32 3 34 19v7c-1 7-5 13-10 17-35 24-58 63-58 109 0 71 57 130 128 131s131-58 132-130c0-46-23-86-58-110-6-5-10-12-10-20 0-18 18-30 34-23zm-96 331c-42 0-75 34-75 76s33 76 75 76 75-34 75-76-33-76-75-76z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfection);
export default __webpack_public_path__ + "static/media/ic_infection.3e95a020e0595e6e32721d70ee5a40f4.svg";
export { ForwardRef as ReactComponent };